module.exports = __webpack_public_path__ + "img/20_dice[14].5d126c93.png";